import { memo, useEffect } from "react";

import { LoadingIcon } from "@/assets/icons";
import { Toaster } from "@/components/ui/sonner";
import { Toaster as CustomToaster } from "@/components/ui/toaster";
import { API_URL } from "@/config/api";

import { notificationAction } from "@/features/notification/redux/notification.slice";
import { INotification } from "@/features/notification/types/notification.type";
import { getNotificationText } from "@/features/notification/utils/notificationText";
import { useAppDispatch, useAppSelector } from "@/redux/store";
import RoutesWrapper from "@/routes/RoutesWrapper";
import { formatDistance } from "@/utils/date";

import { Avatar, AvatarFallback } from "../ui/avatar";
import { Dialog, DialogContent } from "../ui/dialog";
import { useToast } from "../ui/use-toast";
import InsideLayout from "./InsideLayout";

const Default = () => {
  const dispatch = useAppDispatch();
  const { notifications } = useAppSelector((state) => state.notification);
  const loadingGlobal = useAppSelector((state) => state.common.loading);
  const { user } = useAppSelector((state) => state.auth);
  const { toast } = useToast();

  useEffect(() => {
    if (!user?.id) {
      return;
    }
    const urlEndpoint =
      API_URL + "/api/v1/notification/event?userId=" + user?.id;
    const eventSource = new EventSource(urlEndpoint);
    function listenEvent(event: MessageEvent) {
      const decode = event.data.replace(/\+/g, " ");
      const decodedText = decodeURIComponent(decode);
      const item = JSON.parse(decodedText) as INotification;
      toast({
        variant: "default",
        description: (
          <div>
            {item.photoUrl ? (
              <img
                src={item.photoUrl}
                alt=""
                className="w-10 h-10 object-cover"
              />
            ) : (
              <Avatar className="size-10">
                <AvatarFallback>{item.sender.name?.charAt(0)}</AvatarFallback>
              </Avatar>
            )}
            <div>
              <div
                className="text-sm mb-1"
                dangerouslySetInnerHTML={{
                  __html: getNotificationText(item),
                }}
              ></div>
              <p className="text-xs text-secondary-600">
                {formatDistance(item.createdAt)} trước
              </p>
            </div>
          </div>
        ),
      });
      if (!notifications.find((notify) => notify.id === item.id)) {
        dispatch(notificationAction.addNotification(item));
      }
    }
    eventSource.addEventListener("notificationEvent", listenEvent);
    eventSource.addEventListener("error", () => {
      eventSource.close();
    });
    return () => {
      eventSource.removeEventListener("notificationEvent", listenEvent);
      eventSource.removeEventListener("error", () => {
        eventSource.close();
      });
      eventSource.close();
    };
  }, [user?.id, notifications, dispatch]);

  return (
    <div className="app min-h-screen">
      {/* Global Loading Dialog */}
      <Dialog open={loadingGlobal.show}>
        <DialogContent className="p-6 text-center max-w-[400px] gap-2">
          <LoadingIcon className="animate-spin duration-[3000ms] mx-auto" />
          <p className="text-secondary-900 text-lg font-semibold mt-2">
            {loadingGlobal.title}
          </p>
          <p className="text-secondary-600 text-sm">
            {loadingGlobal.description}
          </p>
        </DialogContent>
      </Dialog>

      <Toaster />
      <CustomToaster />
      <InsideLayout>
        <RoutesWrapper />
      </InsideLayout>
    </div>
  );
};

export default memo(Default);
